import { AppRoutes } from './components/AppRoutes';
import './styles/main.css'

const App = () => {
return (
<div className='container'>
    <AppRoutes />
</div>
);
}

export default App 